<template>
  <Toast />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium">
    <li><a class="text-500 no-underline line-height-3 cursor-pointer">REPORTES</a></li>
    <li class="px-2"><i class="pi pi-angle-right text-500 line-height-3"></i></li>
    <li><span class="text-900 line-height-3 active">INFORME MENSUAL Y GESTIÓN</span></li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12" style="border: 1px solid #000000">
    <div class="flex align-items-center flex-column lg:justify-content-center lg:flex-row">
      <span style="border-bottom: 1px solid #005f91; font-size: 1.5rem">
        <strong>INFORME POR MES Y GESTIÓN</strong>
      </span>
    </div>

    <div class="col-12">
      <div class="p-fluid formgrid grid p-fondo">
        <div class="field col-12 md:col-3">
          <span><strong>SELECCIONE SUCURSAL: </strong></span>
          <div class="p-inputgroup">
            <Dropdown
              :disabled="true"
              v-model="sucursalSelected"
              :options="sucursales"
              optionLabel="nombre"
              optionValue="id"
              placeholder="Seleccione una sucursal"
            />
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>SELECCIONE MES: </strong></span>
          <div class="p-inputgroup">
            <Dropdown v-model="mes_seleccionado" :options="meses" optionLabel="label" placeholder="Seleccione un mes" />
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>SELECCIONE AÑO: </strong></span>
          <div class="p-inputgroup">
            <InputNumber
              v-model="anio_gestion"
              :min="2021"
              :max="new Date().getFullYear()"
              :showButtons="true"
              mode="decimal"
              :useGrouping="false"
            />
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <span><strong>ACCIONES: </strong></span>
          <Button
            label="APLICAR FILTROS"
            icon="pi pi-search"
            class="p-button-info"
            v-tooltip.top="'Aplicar Filtros de Busqueda'"
            :loading="enviando"
            :disabled="enviando"
            @click="BuscarFiltro"
          />
        </div>
      </div>

      <div class="p-fluid formgrid grid mt-2">
        <div class="field col-12">
          <div v-if="enviando" class="text-center"><ProgressSpinner /></div>

          <div v-if="semana1.length || semana2.length || semana3.length || semana4.length || semana5.length">
            <!-- BALANCE + GRÁFICOS -->
            <div class="grid mt-3">
              <!-- BALANCE -->
              <div class="col-12 md:col-5">
                <div class="card p-3" style="height: 100%">
                  <div
                    class="flex align-items-center gap-2 mb-3"
                    style="border-bottom: 2px solid #005f91; padding-bottom: 6px"
                  >
                    <i class="pi pi-chart-line text-primary"></i>
                    <strong>BALANCE - {{ mesLabel }} {{ anio_gestion }}</strong>
                  </div>

                  <table style="width: 100%; font-size: 13px; border-collapse: collapse" class="mb-2">
                    <tr style="background: #f0f7ff">
                      <td style="padding: 5px 8px">
                        <i class="pi pi-arrow-up text-green-500 mr-1"></i><strong>INGRESOS</strong>
                      </td>
                      <td
                        style="padding: 5px 8px; text-align: right; color: #27ae60; font-weight: 700; font-size: 14px"
                      >
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensualCaja.total_ingresos_caja) }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 8px 3px 24px; color: #555; font-size: 12px">
                        <i class="pi pi-cog mr-1 text-xs"></i>Servicios
                      </td>
                      <td style="padding: 3px 8px; text-align: right; color: #555; font-size: 12px">
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensual.total_servicios) }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 8px 3px 24px; color: #555; font-size: 12px">
                        <i class="pi pi-box mr-1 text-xs"></i>Productos
                      </td>
                      <td style="padding: 3px 8px; text-align: right; color: #555; font-size: 12px">
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensual.total_productos) }}
                      </td>
                    </tr>
                    <tr style="background: #fff3f3">
                      <td style="padding: 5px 8px">
                        <i class="pi pi-arrow-down text-red-500 mr-1"></i><strong>EGRESOS</strong>
                      </td>
                      <td
                        style="padding: 5px 8px; text-align: right; color: #e74c3c; font-weight: 700; font-size: 14px"
                      >
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensualCaja.total_egresos_caja) }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 8px 3px 24px; color: #555; font-size: 12px">
                        <i class="pi pi-users mr-1 text-xs"></i>Comisiones
                      </td>
                      <td style="padding: 3px 8px; text-align: right; color: #555; font-size: 12px">
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensualCaja.total_comisiones) }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 8px 3px 24px; color: #555; font-size: 12px">
                        <i class="pi pi-list mr-1 text-xs"></i>Costos
                      </td>
                      <td style="padding: 3px 8px; text-align: right; color: #555; font-size: 12px">
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensualCaja.total_costos) }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 8px 3px 24px; color: #555; font-size: 12px">
                        <i class="pi pi-shopping-bag mr-1 text-xs"></i>Compras
                      </td>
                      <td style="padding: 3px 8px; text-align: right; color: #555; font-size: 12px">
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensualCaja.total_compras) }}
                      </td>
                    </tr>
                    <tr style="background: #1e3a5f; color: #fff">
                      <td style="padding: 8px"><i class="pi pi-wallet mr-1"></i><strong>SALDO NETO</strong></td>
                      <td style="padding: 8px; text-align: right; font-size: 16px; font-weight: 700">
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensualCaja.total_dia) }}
                      </td>
                    </tr>
                  </table>

                  <div style="font-size: 12px; font-weight: 700; color: #555; margin: 8px 0 4px">
                    <i class="pi pi-wrench mr-1"></i>OPERACIONES
                  </div>
                  <table style="width: 100%; font-size: 12px; border-collapse: collapse">
                    <tr style="background: #f8f9fa">
                      <td style="padding: 3px 6px">
                        <i class="pi pi-check-circle text-green-500 mr-1"></i>Servicios pagados
                        <i
                          class="pi pi-eye text-blue-400 ml-1"
                          style="cursor: pointer; font-size: 11px"
                          v-tooltip.top="'Ver desglose'"
                          @click="modalServicios = true"
                        ></i>
                      </td>
                      <td style="padding: 3px 6px; text-align: right; font-weight: 700">
                        {{
                          (resumenMensual.total_servicios_pagados ?? 0) - (resumenMensual.total_compra_membresia ?? 0)
                        }}
                      </td>
                      <td style="padding: 3px 6px; text-align: right; color: #27ae60; font-weight: 700">
                        Bs.
                        {{
                          convertirNumeroGermanicFormat(
                            (resumenMensual.total_servicios ?? 0) - (resumenMensual.total_bs_membresias_nuevas ?? 0)
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 6px">
                        <i class="pi pi-credit-card text-blue-500 mr-1"></i>Usos de membresía
                      </td>
                      <td style="padding: 3px 6px; text-align: right; font-weight: 700">
                        {{ resumenMensual.total_usos_membresia ?? 0 }}
                      </td>
                      <td style="padding: 3px 6px; text-align: right; color: #aaa">Bs. 0,00</td>
                    </tr>
                    <tr style="background: #f8f9fa">
                      <td style="padding: 3px 6px">
                        <i class="pi pi-tag text-purple-500 mr-1"></i>Membresías nuevas
                        <i
                          class="pi pi-eye text-blue-400 ml-1"
                          style="cursor: pointer; font-size: 11px"
                          v-tooltip.top="'Ver detalle'"
                          @click="modalMembresias = true"
                        ></i>
                      </td>
                      <td style="padding: 3px 6px; text-align: right; font-weight: 700">
                        {{ resumenMensual.total_compra_membresia ?? 0 }}
                      </td>
                      <td style="padding: 3px 6px; text-align: right; color: #27ae60; font-weight: 700">
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensual.total_bs_membresias_nuevas ?? 0) }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 6px"><i class="pi pi-tag text-orange-500 mr-1"></i>Cortesías</td>
                      <td style="padding: 3px 6px; text-align: right; font-weight: 700">
                        {{ resumenMensual.total_cortesias ?? 0 }}
                      </td>
                      <td style="padding: 3px 6px; text-align: right; color: #aaa">Bs. 0,00</td>
                    </tr>
                    <tr style="background: #f8f9fa">
                      <td style="padding: 3px 6px">
                        <i class="pi pi-dollar text-primary mr-1"></i>Ingreso prom./serv.
                      </td>
                      <td colspan="2" style="padding: 3px 6px; text-align: right; font-weight: 700; color: #27ae60">
                        Bs. {{ convertirNumeroGermanicFormat(resumenMensual.promedio_por_servicio ?? 0) }}
                      </td>
                    </tr>
                  </table>

                  <div style="font-size: 12px; font-weight: 700; color: #555; margin: 8px 0 4px">
                    <i class="pi pi-car mr-1"></i>VEHÍCULOS Y MEMBRESÍAS
                  </div>
                  <table style="width: 100%; font-size: 12px; border-collapse: collapse">
                    <tr style="background: #f8f9fa">
                      <td style="padding: 3px 6px">
                        <i class="pi pi-car text-primary mr-1"></i>Autos únicos atendidos
                      </td>
                      <td style="padding: 3px 6px; text-align: right; font-weight: 700">
                        {{ resumenMensual.total_vehiculos_distintos ?? 0 }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 6px">
                        <i class="pi pi-check-circle text-green-500 mr-1"></i>Membresías activas
                      </td>
                      <td style="padding: 3px 6px; text-align: right; font-weight: 700">
                        {{ resumenMensual.membresias_activas ?? 0 }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 3px 6px">
                        <i class="pi pi-times-circle text-red-400 mr-1"></i>Vencidas este mes
                      </td>
                      <td style="padding: 3px 6px; text-align: right; font-weight: 700">
                        {{ resumenMensual.membresias_vencidas ?? 0 }}
                      </td>
                    </tr>
                  </table>

                  <div
                    v-if="objetivos_mes && objetivos_mes.length"
                    style="font-size: 12px; font-weight: 700; color: #555; margin: 8px 0 4px"
                  >
                    <i class="pi pi-flag mr-1"></i>OBJETIVOS DEL MES
                  </div>
                  <div v-for="obj in objetivos_mes ?? []" :key="obj.id" class="mb-1">
                    <div
                      style="
                        font-size: 12px;
                        font-weight: 700;
                        background: #f0f7ff;
                        padding: 4px 6px;
                        border-radius: 4px;
                        border-left: 3px solid #1e3a5f;
                      "
                    >
                      {{ obj.nombre }}
                      <span class="ml-1" style="color: #888; font-weight: 400"
                        >({{ obj.estado == 1 ? 'Activo' : 'Liquidado' }})</span
                      >
                    </div>
                    <table style="width: 100%; font-size: 12px; border-collapse: collapse; margin-top: 2px">
                      <tr v-for="av in obj.avances" :key="av.medico_id" style="border-bottom: 1px solid #eee">
                        <td style="padding: 3px 6px">
                          <i class="pi pi-user mr-1 text-primary"></i>{{ av.nombre_completo }}
                        </td>
                        <td style="padding: 3px 6px; text-align: center">
                          {{ parseInt(av.total_unidades) }} serv.
                          <i
                            v-if="av.detalle && av.detalle.length"
                            class="pi pi-eye text-blue-400 ml-1"
                            style="cursor: pointer; font-size: 11px"
                            v-tooltip.top="'Ver detalle'"
                            @click="abrirDetalleObjetivo(av)"
                          ></i>
                        </td>
                        <td style="padding: 3px 6px; text-align: center">
                          <span
                            v-if="av.escala_actual"
                            style="
                              background: #27ae60;
                              color: #fff;
                              border-radius: 3px;
                              padding: 1px 6px;
                              font-size: 11px;
                            "
                          >
                            Escala {{ av.escala_actual }}
                          </span>
                          <span v-else style="color: #e74c3c; font-size: 11px">Sin escala</span>
                        </td>
                        <td style="padding: 3px 6px; text-align: right; font-weight: 700; color: #27ae60">
                          Bs. {{ convertirNumeroGermanicFormat(av.monto_a_pagar) }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <!-- GRÁFICOS -->
              <div class="col-12 md:col-7">
                <div class="card p-3 mb-2">
                  <div
                    class="flex align-items-center gap-2 mb-2"
                    style="border-bottom: 2px solid #005f91; padding-bottom: 6px"
                  >
                    <i class="pi pi-chart-bar text-primary"></i>
                    <strong>INGRESOS VS EGRESOS POR SEMANA</strong>
                  </div>
                  <canvas ref="chartBarras" height="130"></canvas>
                </div>
                <div class="card p-3">
                  <div
                    class="flex align-items-center gap-2 mb-2"
                    style="border-bottom: 2px solid #005f91; padding-bottom: 6px"
                  >
                    <i class="pi pi-chart-pie text-primary"></i>
                    <strong>DESGLOSE DE SERVICIOS</strong>
                  </div>
                  <div class="flex align-items-center gap-3">
                    <canvas ref="chartDonut" style="max-width: 160px; max-height: 160px"></canvas>
                    <div style="font-size: 13px">
                      <div class="flex align-items-center gap-2 mb-2">
                        <span
                          style="
                            width: 12px;
                            height: 12px;
                            background: #27ae60;
                            border-radius: 2px;
                            display: inline-block;
                          "
                        ></span>
                        <span
                          >Pagados: <strong>{{ resumenMensual.total_servicios_pagados ?? 0 }}</strong></span
                        >
                      </div>
                      <div class="flex align-items-center gap-2 mb-2">
                        <span
                          style="
                            width: 12px;
                            height: 12px;
                            background: #3b82f6;
                            border-radius: 2px;
                            display: inline-block;
                          "
                        ></span>
                        <span
                          >Membresía (uso): <strong>{{ resumenMensual.total_usos_membresia ?? 0 }}</strong></span
                        >
                      </div>
                      <div class="flex align-items-center gap-2 mb-2">
                        <span
                          style="
                            width: 12px;
                            height: 12px;
                            background: #9b59b6;
                            border-radius: 2px;
                            display: inline-block;
                          "
                        ></span>
                        <span
                          >Membresía (nueva): <strong>{{ resumenMensual.total_compra_membresia ?? 0 }}</strong></span
                        >
                      </div>
                      <div class="flex align-items-center gap-2">
                        <span
                          style="
                            width: 12px;
                            height: 12px;
                            background: #f97316;
                            border-radius: 2px;
                            display: inline-block;
                          "
                        ></span>
                        <span
                          >Cortesías: <strong>{{ resumenMensual.total_cortesias ?? 0 }}</strong></span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- TABLAS SEMANALES -->
            <template v-for="(semana, index) in [semana1, semana2, semana3, semana4, semana5]" :key="index">
              <div v-if="semana.length > 0" class="mb-4">
                <h3 class="estilo_dias">Semana {{ index + 1 }}</h3>
                <div class="table-responsive" style="overflow-x: auto">
                  <table class="table table-striped table-bordered">
                    <thead class="thead-dark">
                      <tr>
                        <th rowspan="2">Fecha</th>
                        <th colspan="3">Productos</th>
                        <th colspan="8">Servicios</th>
                        <th colspan="3">Caja</th>
                        <th rowspan="2">Compras</th>
                        <th rowspan="2">Costos</th>
                        <th rowspan="2">Total</th>
                      </tr>
                      <tr>
                        <th>Cant.</th>
                        <th v-tooltip.top="'Cant. x Precio'">Total Bs.</th>
                        <th v-tooltip.top="'Total / Cant.'">Prom. Bs.</th>
                        <th>Total</th>
                        <th>Total Bs.</th>
                        <th>Pagados</th>
                        <th>Memb.(uso)</th>
                        <th>Memb.(nueva)</th>
                        <th>Cort.</th>
                        <th>Vehíc.</th>
                        <th v-tooltip.top="'(Cant. - Membresías gratuitas) / Total'">Prom. Bs.</th>
                        <th>Ingresos</th>
                        <th>Egresos</th>
                        <th>Comisiones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(dato, idx) in semana" :key="idx">
                        <td>{{ formatFecha(dato.fecha) }}</td>
                        <td>{{ sinDecimales(dato.cant_productos) }}</td>
                        <td>{{ convertirNumeroGermanicFormat(dato.total_productos) }}</td>
                        <td>{{ getPromedioProductos(dato.total_productos, dato.cant_productos) }}</td>
                        <td>{{ sinDecimales(dato.cant_servicios) }}</td>
                        <td>{{ convertirNumeroGermanicFormat(dato.total_servicios) }}</td>
                        <td>{{ sinDecimales(dato.cant_servicios_pagados ?? 0) }}</td>
                        <td>{{ sinDecimales(dato.cant_usos_membresia ?? 0) }}</td>
                        <td>{{ sinDecimales(dato.cant_compra_membresia ?? 0) }}</td>
                        <td>{{ sinDecimales(dato.cant_cortesias ?? 0) }}</td>
                        <td>{{ sinDecimales(dato.cant_vehiculos ?? 0) }}</td>
                        <td>
                          {{ getPromedioServicios(dato.total_servicios, dato.cant_servicios, dato.cant_membresias) }}
                        </td>
                        <td>{{ convertirNumeroGermanicFormat(dato.total_ingresos_caja) }}</td>
                        <td>{{ convertirNumeroGermanicFormat(dato.total_egresos_mov_caja) }}</td>
                        <td>{{ convertirNumeroGermanicFormat(dato.total_comisiones) }}</td>
                        <td>{{ convertirNumeroGermanicFormat(dato.total_compras) }}</td>
                        <td>{{ convertirNumeroGermanicFormat(dato.total_costos) }}</td>
                        <td>{{ convertirNumeroGermanicFormat(dato.total_dia) }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td class="text-right"><strong>TOTALES</strong></td>
                        <td>
                          <strong>{{ sinDecimales(semana.reduce((a, i) => a + i.cant_productos, 0)) }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            convertirNumeroGermanicFormat(semana.reduce((a, i) => a + i.total_productos, 0))
                          }}</strong>
                        </td>
                        <td></td>
                        <td>
                          <strong>{{ sinDecimales(semana.reduce((a, i) => a + i.cant_servicios, 0)) }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            convertirNumeroGermanicFormat(semana.reduce((a, i) => a + i.total_servicios, 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            sinDecimales(semana.reduce((a, i) => a + (i.cant_servicios_pagados ?? 0), 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            sinDecimales(semana.reduce((a, i) => a + (i.cant_usos_membresia ?? 0), 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            sinDecimales(semana.reduce((a, i) => a + (i.cant_compra_membresia ?? 0), 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{ sinDecimales(semana.reduce((a, i) => a + (i.cant_cortesias ?? 0), 0)) }}</strong>
                        </td>
                        <td>
                          <strong>{{ sinDecimales(semana.reduce((a, i) => a + (i.cant_vehiculos ?? 0), 0)) }}</strong>
                        </td>
                        <td></td>
                        <td>
                          <strong>{{
                            convertirNumeroGermanicFormat(semana.reduce((a, i) => a + i.total_ingresos_caja, 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            convertirNumeroGermanicFormat(semana.reduce((a, i) => a + i.total_egresos_mov_caja, 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            convertirNumeroGermanicFormat(semana.reduce((a, i) => a + i.total_comisiones, 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            convertirNumeroGermanicFormat(semana.reduce((a, i) => a + i.total_compras, 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            convertirNumeroGermanicFormat(semana.reduce((a, i) => a + i.total_costos, 0))
                          }}</strong>
                        </td>
                        <td>
                          <strong>{{
                            convertirNumeroGermanicFormat(semana.reduce((a, i) => a + i.total_dia, 0))
                          }}</strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </template>
          </div>

          <div v-else class="text-center">
            <span style="color: red; font-size: 1.2rem; font-weight: bold; text-align: center">
              <i class="pi pi-info-circle"></i> Por favor, seleccione un mes y año para mostrar los datos.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL DESGLOSE SERVICIOS PAGADOS -->
  <Dialog
    v-model:visible="modalServicios"
    modal
    :header="'SERVICIOS PAGADOS - ' + mesLabel + ' ' + anio_gestion"
    :style="{ width: '520px' }"
  >
    <div v-if="resumenMensual.servicios_pagados_detalle && resumenMensual.servicios_pagados_detalle.length">
      <table style="width: 100%; border-collapse: collapse; font-size: 13px">
        <thead>
          <tr style="background: #002236; color: #fff">
            <th style="padding: 6px 10px; text-align: left">SERVICIO</th>
            <th style="padding: 6px 10px; text-align: center">CANT.</th>
            <th style="padding: 6px 10px; text-align: right">TOTAL Bs.</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(s, i) in resumenMensual.servicios_pagados_detalle"
            :key="i"
            :style="{ background: i % 2 === 0 ? '#f9f9f9' : '#fff' }"
          >
            <td style="padding: 5px 10px"><i class="pi pi-wrench text-primary mr-1"></i>{{ s.nombre }}</td>
            <td style="padding: 5px 10px; text-align: center; font-weight: 700">{{ s.cantidad }}</td>
            <td style="padding: 5px 10px; text-align: right; color: #27ae60; font-weight: 700">
              {{ convertirNumeroGermanicFormat(s.total_bs) }}
            </td>
          </tr>
          <!-- FILA MEMBRESÍAS NUEVAS como referencia -->
          <tr v-if="(resumenMensual.total_bs_membresias_nuevas ?? 0) > 0" style="background: #f3eeff">
            <td style="padding: 5px 10px">
              <i class="pi pi-tag text-purple-500 mr-1"></i>
              <em style="color: #7c3aed">Membresías nuevas (ref.)</em>
            </td>
            <td style="padding: 5px 10px; text-align: center; font-weight: 700; color: #7c3aed">
              {{ resumenMensual.total_compra_membresia ?? 0 }}
            </td>
            <td style="padding: 5px 10px; text-align: right; color: #7c3aed; font-weight: 700">
              {{ convertirNumeroGermanicFormat(resumenMensual.total_bs_membresias_nuevas ?? 0) }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="background: #1e3a5f; color: #fff; font-weight: 700">
            <td style="padding: 6px 10px">TOTAL</td>
            <td style="padding: 6px 10px; text-align: center">{{ resumenMensual.total_servicios_pagados ?? 0 }}</td>
            <td style="padding: 6px 10px; text-align: right">
              Bs.
              {{
                convertirNumeroGermanicFormat(
                  (resumenMensual.servicios_pagados_detalle ?? []).reduce((a, s) => a + parseFloat(s.total_bs || 0), 0)
                )
              }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-else class="text-center p-4" style="color: #888">
      <i class="pi pi-info-circle mr-1"></i> No hay servicios pagados este mes.
    </div>
    <template #footer>
      <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modalServicios = false" />
    </template>
  </Dialog>

  <!-- MODAL DETALLE OBJETIVO -->
  <Dialog
    v-model:visible="modalDetalleObjetivo"
    modal
    :header="'Detalle - ' + (detalleObjetivoData.nombre_completo ?? '')"
    :style="{ width: '450px' }"
  >
    <div v-if="detalleObjetivoData.detalle && detalleObjetivoData.detalle.length">
      <div class="flex justify-content-between mb-2 p-2" style="background: #f0f7ff; border-radius: 4px">
        <span style="font-weight: 700">Total servicios: {{ parseInt(detalleObjetivoData.total_unidades) }}</span>
        <span style="font-weight: 700; color: #27ae60"
          >Bs.
          {{
            convertirNumeroGermanicFormat(
              detalleObjetivoData.detalle
                ? detalleObjetivoData.detalle.reduce((a, d) => a + parseFloat(d.monto_total || 0), 0)
                : 0
            )
          }}</span
        >
      </div>
      <table style="border-collapse: collapse; width: 100%; font-size: 13px">
        <thead>
          <tr style="background: #1e3a5f; color: #fff">
            <th style="padding: 8px; text-align: left">SERVICIO</th>
            <th style="padding: 8px; text-align: right; width: 60px">CANT.</th>
            <th style="padding: 8px; text-align: right; width: 100px">MONTO</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in detalleObjetivoData.detalle" :key="d.producto_nombre" style="border-bottom: 1px solid #eee">
            <td style="padding: 6px 8px">{{ d.producto_nombre }}</td>
            <td style="padding: 6px 8px; text-align: right; font-weight: 700">{{ d.cantidad }}</td>
            <td style="padding: 6px 8px; text-align: right; color: #555">
              Bs. {{ convertirNumeroGermanicFormat(d.monto_total) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-center p-4" style="color: #888">
      <i class="pi pi-info-circle mr-1"></i> Sin detalle disponible.
    </div>
    <template #footer>
      <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modalDetalleObjetivo = false" />
    </template>
  </Dialog>

  <!-- MODAL DETALLE MEMBRESÍAS NUEVAS -->
  <Dialog
    v-model:visible="modalMembresias"
    modal
    :header="'MEMBRESÍAS NUEVAS - ' + mesLabel + ' ' + anio_gestion"
    :style="{ width: '520px' }"
  >
    <div v-if="resumenMensual.membresias_detalle && resumenMensual.membresias_detalle.length">
      <table style="width: 100%; border-collapse: collapse; font-size: 13px">
        <thead>
          <tr style="background: #002236; color: #fff">
            <th style="padding: 6px 10px; text-align: left">MEMBRESÍA</th>
            <th style="padding: 6px 10px; text-align: center">CANT.</th>
            <th style="padding: 6px 10px; text-align: right">TOTAL Bs.</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(m, i) in resumenMensual.membresias_detalle"
            :key="i"
            :style="{ background: i % 2 === 0 ? '#f9f9f9' : '#fff' }"
          >
            <td style="padding: 5px 10px"><i class="pi pi-credit-card text-purple-500 mr-1"></i>{{ m.nombre }}</td>
            <td style="padding: 5px 10px; text-align: center; font-weight: 700">{{ m.cantidad }}</td>
            <td style="padding: 5px 10px; text-align: right; color: #27ae60; font-weight: 700">
              {{ convertirNumeroGermanicFormat(m.total_bs) }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="background: #1e3a5f; color: #fff; font-weight: 700">
            <td style="padding: 6px 10px">TOTAL</td>
            <td style="padding: 6px 10px; text-align: center">{{ resumenMensual.total_compra_membresia ?? 0 }}</td>
            <td style="padding: 6px 10px; text-align: right">
              Bs. {{ convertirNumeroGermanicFormat(resumenMensual.total_bs_membresias_nuevas ?? 0) }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-else class="text-center p-4" style="color: #888">
      <i class="pi pi-info-circle mr-1"></i> No hay membresías nuevas este mes.
    </div>
    <template #footer>
      <Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modalMembresias = false" />
    </template>
  </Dialog>
</template>

<script>
import VentaService from '@/service/VentaService'
import SucursalService from '@/service/SucursalService'
import { useAuth } from '@/stores'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)

export default {
  data() {
    return {
      enviando: false,
      sucursalSelected: 0,
      sucursales: [{ id: 0, nombre: 'TODAS' }],
      meses: [
        { label: 'ENERO', value: 1 },
        { label: 'FEBRERO', value: 2 },
        { label: 'MARZO', value: 3 },
        { label: 'ABRIL', value: 4 },
        { label: 'MAYO', value: 5 },
        { label: 'JUNIO', value: 6 },
        { label: 'JULIO', value: 7 },
        { label: 'AGOSTO', value: 8 },
        { label: 'SEPTIEMBRE', value: 9 },
        { label: 'OCTUBRE', value: 10 },
        { label: 'NOVIEMBRE', value: 11 },
        { label: 'DICIEMBRE', value: 12 }
      ],
      mes_seleccionado: null,
      anio_gestion: new Date().getFullYear(),
      semana1: [],
      semana2: [],
      semana3: [],
      semana4: [],
      semana5: [],
      resumenMensual: {
        total_cant_productos: 0,
        total_productos: 0,
        total_cant_servicios: 0,
        total_servicios: 0,
        total_servicios_pagados: 0,
        total_usos_membresia: 0,
        total_compra_membresia: 0,
        total_cortesias: 0,
        total_vehiculos_distintos: 0,
        promedio_por_servicio: 0,
        membresias_activas: 0,
        membresias_nuevas: 0,
        membresias_vencidas: 0,
        membresias_detalle: [],
        total_bs_membresias_nuevas: 0,
        servicios_pagados_detalle: []
      },
      resumenMensualProdServ: {
        total_cant_productos: 0,
        total_productos: 0,
        total_cant_servicios: 0,
        total_servicios: 0,
        total_cant_membresias: 0
      },
      resumenMensualCaja: {
        total_ingresos_caja: 0,
        total_egresos_mov_caja: 0,
        total_comisiones: 0,
        total_costos: 0,
        total_compras: 0,
        total_egresos_caja: 0,
        total_dia: 0
      },
      objetivos_mes: [],
      totales_semanas: {},
      chartBarrasInstance: null,
      chartDonutInstance: null,
      modalServicios: false,
      modalMembresias: false,
      modalDetalleObjetivo: false,
      detalleObjetivoData: {}
    }
  },

  computed: {
    mesLabel() {
      return this.mes_seleccionado?.label ?? ''
    }
  },

  created() {
    this.ventaService = new VentaService()
    this.sucursalService = new SucursalService()
    this.auth = useAuth()
  },

  mounted() {
    this.cargarSucursales()
    this.mes_seleccionado = this.meses.find((m) => m.value === new Date().getMonth() + 1)
  },

  methods: {
    getPromedioProductos(total, cantidad) {
      return cantidad > 0 ? this.convertirNumeroGermanicFormat(total / cantidad) : 0
    },
    getPromedioServicios(total, cantidad, membresias) {
      const c = cantidad - membresias
      return c > 0 ? this.convertirNumeroGermanicFormat(total / c) : 0
    },

    BuscarFiltro() {
      this.semana1 = []
      this.semana2 = []
      this.semana3 = []
      this.semana4 = []
      this.semana5 = []
      this.enviando = true
      this.cargarReporteMensualGestion()
    },

    cargarReporteMensualGestion() {
      const datos = {
        sucursal_id: this.sucursalSelected,
        anio_gestion: this.anio_gestion,
        mes_seleccionado: this.mes_seleccionado.value
      }
      this.ventaService
        .filtrarReporteMensualGestion(datos)
        .then((data) => {
          this.semana1 = data.datos?.semana1 ?? []
          this.semana2 = data.datos?.semana2 ?? []
          this.semana3 = data.datos?.semana3 ?? []
          this.semana4 = data.datos?.semana4 ?? []
          this.semana5 = data.datos?.semana5 ?? []
          this.resumenMensualProdServ = data.resumenMensualProdServ ?? this.resumenMensualProdServ
          this.resumenMensualCaja = data.resumenMensualCaja ?? this.resumenMensualCaja
          this.resumenMensual = data.resumenMensual ?? this.resumenMensual
          this.objetivos_mes = data.objetivos_mes ?? []
          this.totales_semanas = data.totales_semanas ?? {}
          this.enviando = false
          this.$nextTick(() => {
            this.renderGraficos()
          })
        })
        .catch((error) => {
          this.enviando = false
          console.log(error)
        })
    },

    renderGraficos() {
      if (this.chartBarrasInstance) this.chartBarrasInstance.destroy()
      if (this.chartDonutInstance) this.chartDonutInstance.destroy()

      const semLabels = ['Sem 1', 'Sem 2', 'Sem 3', 'Sem 4', 'Sem 5']
      const dataIngresos = semLabels.map((_, i) => this.totales_semanas[`semana${i + 1}`]?.total_ingresos ?? 0)
      const dataEgresos = semLabels.map((_, i) => this.totales_semanas[`semana${i + 1}`]?.total_egresos ?? 0)

      if (this.$refs.chartBarras) {
        this.chartBarrasInstance = new Chart(this.$refs.chartBarras, {
          type: 'bar',
          data: {
            labels: semLabels,
            datasets: [
              { label: 'Ingresos Bs.', data: dataIngresos, backgroundColor: '#27ae60', borderRadius: 4 },
              { label: 'Egresos Bs.', data: dataEgresos, backgroundColor: '#e74c3c', borderRadius: 4 }
            ]
          },
          options: {
            responsive: true,
            plugins: { legend: { display: true, position: 'top', labels: { font: { size: 12 }, padding: 10 } } },
            scales: { y: { beginAtZero: true, ticks: { callback: (v) => 'Bs. ' + v.toLocaleString('de-DE') } } }
          }
        })
      }

      if (this.$refs.chartDonut) {
        this.chartDonutInstance = new Chart(this.$refs.chartDonut, {
          type: 'doughnut',
          data: {
            labels: ['Pagados', 'Memb.(uso)', 'Memb.(nueva)', 'Cortesías'],
            datasets: [
              {
                data: [
                  this.resumenMensual.total_servicios_pagados ?? 0,
                  this.resumenMensual.total_usos_membresia ?? 0,
                  this.resumenMensual.total_compra_membresia ?? 0,
                  this.resumenMensual.total_cortesias ?? 0
                ],
                backgroundColor: ['#27ae60', '#3b82f6', '#9b59b6', '#f97316'],
                borderWidth: 2
              }
            ]
          },
          options: { responsive: true, plugins: { legend: { display: false } }, cutout: '65%' }
        })
      }
    },

    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(numero)
    },
    sinDecimales(numero) {
      return (Math.round(numero * 10) / 10).toLocaleString('es-ES', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    },
    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((data) => {
          data.forEach((s) => this.sucursales.push(s))
        })
        .catch((error) => console.log(error))
    },
    abrirDetalleObjetivo(av) {
      this.detalleObjetivoData = av
      this.modalDetalleObjetivo = true
    },

    formatFecha(fecha) {
      const [year, month, day] = fecha.split('-')
      return new Intl.DateTimeFormat('es-ES', { dateStyle: 'short' }).format(new Date(year, month - 1, day))
    }
  }
}
</script>

<style scoped lang="scss">
.p-fondo {
  background-color: #7bffae;
  border: 1px solid #000000;
  border-bottom: 2px solid #000000;
}
.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background-color: #ffffff;
  padding: 1rem;
}
.card-total {
  position: relative;
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  margin-bottom: 0.5rem;
  height: 100%;
  display: flex;
  align-items: center;
}
.card-total:hover {
  transform: translateY(-3px) scale(1.01);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
}
.card-total::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 4px;
  border-radius: 8px 0 0 8px;
}
.card-total.bg-blue-100::before {
  background-color: #3b82f6;
}
.card-total.bg-orange-100::before {
  background-color: #f97316;
}
.card-total.bg-green-100::before {
  background-color: #22c55e;
}
.card-total.bg-red-100::before {
  background-color: #ef4444;
}
.card-total.bg-gray-100::before {
  background-color: #6b7280;
}
.icon-left {
  margin-right: 0.75rem;
  padding: 0.25rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.icon-blue {
  color: #3b82f6;
}
.icon-orange {
  color: #f97316;
}
.icon-green {
  color: #22c55e;
}
.icon-red {
  color: #ef4444;
}
.icon-gray {
  color: #6b7280;
}
.card-total .text-sm {
  font-size: 0.8rem;
}
.card-total .text-lg {
  font-size: 1.1rem;
}

.table-responsive {
  width: 100%;
  margin-top: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  table {
    width: 100%;
    border-collapse: collapse;
    th,
    td {
      text-align: center;
      vertical-align: middle;
      padding: 0.2rem;
      font-size: 1rem;
      border: 1px solid #ddd;
    }
    th {
      background-color: #002236;
      color: white;
      font-size: 1rem;
      font-weight: bold;
    }
    tbody tr:nth-child(even) {
      background-color: #f9f9f9;
    }
    tbody tr:nth-child(odd) {
      background-color: #ffffff;
    }
    tfoot {
      font-weight: bold;
      background-color: #e9ecef;
      td {
        color: #002236;
      }
    }
    td:nth-child(2),
    td:nth-child(3),
    td:nth-child(4) {
      background-color: #e6f7ff;
      color: #007bff;
    }
    td:nth-child(5),
    td:nth-child(6),
    td:nth-child(7),
    td:nth-child(8),
    td:nth-child(9),
    td:nth-child(10),
    td:nth-child(12) {
      background-color: #fff3cd;
      color: #856404;
    }
    td:nth-child(11) {
      background-color: #e8eaf6;
      color: #3949ab;
    }
    td:nth-child(13),
    td:nth-child(18) {
      background-color: #d4edda;
      color: #155724;
    }
    td:nth-child(14),
    td:nth-child(15),
    td:nth-child(16),
    td:nth-child(17) {
      background-color: #f8d7da;
      color: #721c24;
    }
  }
}
.estilo_dias {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #002236;
  text-transform: uppercase;
  text-align: center;
}
.estilo_resumen_titulo {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  color: #002236;
  text-align: left;
  border-bottom: 2px solid #005f91;
  padding-bottom: 0.5rem;
}
@media (max-width: 768px) {
  table {
    font-size: 0.8rem;
    th,
    td {
      padding: 0.5rem;
    }
  }
  .estilo_dias {
    font-size: 1.2rem;
  }
}
</style>
